// TABLE_NAME: ReportesParametrosTipos
export const TEXT = 1;
export const NUMBER = 2;
export const BOOLEAN = 3;
export const SELECT = 4;
export const DATE = 5;
export const OPTIONS = 6;
export const YEAR = 7;
export const MONTH = 8;
